import testImage from "../assets/test.png";
import testHeroBg from "../assets/testhero.png";

function TestPreparation() {
  return (
    <div className="bg-white">
      <section
        className="relative isolate flex min-h-[180px] items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat sm:min-h-[200px] md:min-h-[220px]"
        style={{ backgroundImage: `url(${testHeroBg})` }}
        aria-labelledby="test-preparation-hero-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/50 to-ink/35"
          aria-hidden
        />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 text-center sm:px-8 sm:py-8 md:px-10 lg:px-8">
          <h1
            id="test-preparation-hero-heading"
            className="text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            Test Preparation
          </h1>
        </div>
      </section>

      <section
        className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24"
        aria-labelledby="test-preparation-heading"
      >
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-light/25 to-transparent"
          aria-hidden
        />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
          <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_420px] lg:items-center lg:gap-14">
            <div className="min-w-0 max-w-3xl">
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
                Exam readiness
              </p>
              <h2
                id="test-preparation-heading"
                className="mt-4 text-balance text-3xl font-bold tracking-tight text-ink sm:text-4xl md:text-[2.375rem] md:leading-tight"
              >
                The Largest Open Schooling System in the world.
              </h2>
              <p className="mt-6 text-pretty text-base leading-relaxed text-ink/75 sm:text-lg">
                We encourage the vast majority of our students to sit for
                international standardized tests such as SAT, ACT, Advanced
                Placement Test, TOEFL and IELTS. Admission officers tell us that
                they see strong value in such assessments for students from our
                school.
              </p>
              <p className="mt-4 text-pretty text-base leading-relaxed text-ink/75 sm:text-lg">
                AOS is proud to partner with SATnPaper, India&apos;s largest high
                school test prep organization. They offer bespoke and exclusive
                one-on-one online prep for all of the above mentioned tests.
                Their highly customized and personalised prep programs are
                delivered as live one-on-one video calls.
              </p>
            </div>

            <div className="mx-auto w-full max-w-md lg:max-w-none">
              <div className="overflow-hidden rounded-2xl border border-brand/10 bg-brand-light/30 shadow-[0_18px_44px_-16px_rgba(30,22,51,0.14)] ring-1 ring-brand/5">
                <img
                  src={testImage}
                  alt="Student filling out a standardized test answer sheet"
                  className="h-full w-full object-cover object-center"
                  width={1024}
                  height={768}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TestPreparation;
